import angular from 'angular';

import { SavedSearches } from './saved-searches.component';
import SearchService from './../searches-manager/search-manager.module';

const MODULE_NAME = 'savedSearches';

export default angular.module(MODULE_NAME, [SearchService]).component('savedSearches', SavedSearches).name;


